export const isSmartPhone = () => {
  return !!navigator.userAgent.match(/iPhone|Android.+Mobile/);
}

export const waitThread = (ms: number): Promise<any> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const scrollToById = ($el: Element, id: string) => {
  const target: any = $el.querySelector('#' + id);
  if (target) {
    target.scrollTop = target.scrollHeight;
  }
}

// タブ、改行を' 'に置換
export const trimText = (text: string) => {
  return text.replace(/\s/g, ' ')
}
